// en folder
import enCommonJSON from "../../locale/en/common.json";
import enCommonAssignationEditJSON from "../../locale/en/commonAssignationEdit.json";
import enCommonDaysJSON from "../../locale/en/commonDays.json";
import enCommonHomeJSON from "../../locale/en/commonHome.json";
import enCommonSidebarMenuJSON from "../../locale/en/commonSidebarMenu.json";
import enCommonGeneralsJSON from "../../locale/en/commonGenerals.json";
import enCommonDimensionJSON from "../../locale/en/commonDimension.json";
import enUserMenuJSON from "../../locale/en/commonUserMenu.json";
import enPackageAndGroupReportJSON from "../../locale/en/commonPackageAndGroupReport.json";
import enCommonRemoveSessionHolidays from "../../locale/en/commonRemoveSessionHolidays.json";
import enCommonLinkChangesHistoryJSON from "../../locale/en/commonLinkChangesHistory.json";
import enCommonContextSelectorJSON from "../../locale/en/commonContextSelector.json";
import enCommonSelectorsJSON from "../../locale/en/commonSelectors.json";
import enCommonGroupChangesHistoryJSON from "../../locale/en/commonGroupChangesHistory.json";
import enCommonGroupManagementJSON from "../../locale/en/commonGroupManagement.json";
import enCommonOnboardingJSON from "../../locale/en/commonOnboarding.json";
import enCommonTenantJSON from "../../locale/en/commonTenant.json";
import enCommonBookingJSON from "../../locale/en/commonBooking.json";
import enCommonGroupsManagerJSON from "../../locale/en/commonGroupsManager.json";
import enCommonCatalogJSON from "../../locale/en/commonCatalog.json";
import enCommonLinkErrorsJSON from "../../locale/en/commonLinkErrors.json";
import enCommonReportJSON from "../../locale/en/commonReport.json";
import enCommonGroupRestrictionsJSON from "../../locale/en/commonGroupRestrictions.json";
import enCommonProgrammingStructures from "../../locale/en/commonProgrammingStructures.json";
import enCommonGroupReferencesJSON from "../../locale/en/commonGroupReferences.json";
import enCommonProgrammingEditJSON from "../../locale/en/commonProgrammingEdit.json";
import enMicroprogrammingGroupsReportJSON from "../../locale/en/commonMicroprogrammingGroupsReport.json";

// es folder
import esCommonJSON from "../../locale/es/common.json";
import esCommonAssignationEditJSON from "../../locale/es/commonAssignationEdit.json";
import esCommonDaysJSON from "../../locale/es/commonDays.json";
import esCommonHomeJSON from "../../locale/es/commonHome.json";
import esCommonSidebarMenuJSON from "../../locale/es/commonSidebarMenu.json";
import esCommonGeneralsJSON from "../../locale/es/commonGenerals.json";
import esCommonDimensionJSON from "../../locale/es/commonDimension.json";
import esUserMenuJSON from "../../locale/es/commonUserMenu.json";
import esPackageAndGroupReportJSON from "../../locale/es/commonPackageAndGroupReport.json";
import esCommonRemoveSessionHolidays from "../../locale/es/commonRemoveSessionHolidays.json";
import esCommonLinkChangesHistoryJSON from "../../locale/es/commonLinkChangesHistory.json";
import esCommonContextSelectorJSON from "../../locale/es/commonContextSelector.json";
import esCommonSelectorsJSON from "../../locale/es/commonSelectors.json";
import esCommonGroupChangesHistoryJSON from "../../locale/es/commonGroupChangesHistory.json";
import esCommonGroupManagementJSON from "../../locale/es/commonGroupManagement.json";
import esCommonOnboardingJSON from "../../locale/es/commonOnboarding.json";
import esCommonTenantJSON from "../../locale/es/commonTenant.json";
import esCommonBookingJSON from "../../locale/es/commonBooking.json";
import esCommonGroupsManagerJSON from "../../locale/es/commonGroupsManager.json";
import esCommonCatalogJSON from "../../locale/es/commonCatalog.json";
import esCommonLinkErrorsJSON from "../../locale/es/commonLinkErrors.json";
import esCommonReportJSON from "../../locale/es/commonReport.json";
import esCommonGroupRestrictionsJSON from "../../locale/es/commonGroupRestrictions.json";
import esCommonProgrammingStructures from "../../locale/es/commonProgrammingStructures.json";
import esCommonGroupReferencesJSON from "../../locale/es/commonGroupReferences.json";
import esCommonProgrammingEditJSON from "../../locale/es/commonProgrammingEdit.json";
import esMicroprogrammingGroupsReportJSON from "../../locale/es/commonMicroprogrammingGroupsReport.json";

export const i18n_KEY_FILES: Record<string, { en: any; es: any }> = {
  common: {
    en: enCommonJSON,
    es: esCommonJSON,
  },
  "assignation-edit": {
    en: enCommonAssignationEditJSON,
    es: esCommonAssignationEditJSON,
  },
  days: {
    en: enCommonDaysJSON,
    es: esCommonDaysJSON,
  },
  home: {
    en: enCommonHomeJSON,
    es: esCommonHomeJSON,
  },
  "sidebar-menu": {
    en: enCommonSidebarMenuJSON,
    es: esCommonSidebarMenuJSON,
  },
  generals: {
    en: enCommonGeneralsJSON,
    es: esCommonGeneralsJSON,
  },
  dimension: {
    en: enCommonDimensionJSON,
    es: esCommonDimensionJSON,
  },
  "user-menu": {
    en: enUserMenuJSON,
    es: esUserMenuJSON,
  },
  "package-and-group-report": {
    en: enPackageAndGroupReportJSON,
    es: esPackageAndGroupReportJSON,
  },
  "remove-session-holidays": {
    en: enCommonRemoveSessionHolidays,
    es: esCommonRemoveSessionHolidays,
  },
  "link-changes-history": {
    en: enCommonLinkChangesHistoryJSON,
    es: esCommonLinkChangesHistoryJSON,
  },
  "context-selector": {
    en: enCommonContextSelectorJSON,
    es: esCommonContextSelectorJSON,
  },
  selectors: {
    en: enCommonSelectorsJSON,
    es: esCommonSelectorsJSON,
  },
  "group-changes-history": {
    en: enCommonGroupChangesHistoryJSON,
    es: esCommonGroupChangesHistoryJSON,
  },
  "group-management": {
    en: enCommonGroupManagementJSON,
    es: esCommonGroupManagementJSON,
  },
  onboarding: {
    en: enCommonOnboardingJSON,
    es: esCommonOnboardingJSON,
  },
  tenant: {
    en: enCommonTenantJSON,
    es: esCommonTenantJSON,
  },
  booking: {
    en: enCommonBookingJSON,
    es: esCommonBookingJSON,
  },
  "groups-manager": {
    en: enCommonGroupsManagerJSON,
    es: esCommonGroupsManagerJSON,
  },
  catalog: {
    en: enCommonCatalogJSON,
    es: esCommonCatalogJSON,
  },
  "link-errors": {
    en: enCommonLinkErrorsJSON,
    es: esCommonLinkErrorsJSON,
  },
  report: {
    en: enCommonReportJSON,
    es: esCommonReportJSON,
  },
  "group-restrictions": {
    en: enCommonGroupRestrictionsJSON,
    es: esCommonGroupRestrictionsJSON,
  },
  "programming-structures": {
    en: enCommonProgrammingStructures,
    es: esCommonProgrammingStructures,
  },
  "group-references": {
    en: enCommonGroupReferencesJSON,
    es: esCommonGroupReferencesJSON,
  },
  "programming-edit": {
    en: enCommonProgrammingEditJSON,
    es: esCommonProgrammingEditJSON,
  },
  "microprogramming-groups-report": {
    en: enMicroprogrammingGroupsReportJSON,
    es: esMicroprogrammingGroupsReportJSON,
  },
};

export const getAllFiles = () => {
  const filesByLocale = {
    en: {},
    es: {},
  };

  Object.keys(i18n_KEY_FILES).forEach(key => {
    const esFile = i18n_KEY_FILES[key].es;
    const enFile = i18n_KEY_FILES[key].en;

    filesByLocale.en = {
      ...filesByLocale.en,
      ...enFile,
    };
    filesByLocale.es = {
      ...filesByLocale.es,
      ...esFile,
    };
  });

  return {
    enFiles: filesByLocale.en,
    esFiles: filesByLocale.es,
  };
};

export const getMainKeysByFile = (): Record<string, { en: any; es: any }> => {
  const keysByFile = {};

  Object.keys(i18n_KEY_FILES).forEach(key => {
    const esFile = i18n_KEY_FILES[key].es;
    const enFile = i18n_KEY_FILES[key].en;

    Object.keys(esFile).forEach(fileKey => {
      keysByFile[fileKey] = {
        en: enFile,
        es: esFile,
      };
    });
  });

  return keysByFile;
};
